export const FETCHING_LOADING = 'FETCHING_LOADING'
export const FETCHING_ITEMS = 'FETCHING_ITEMS'
export const FETCH_ITEMS_ERROR = 'FETCH_ITEMS_ERROR'
export const FETCH_ITEMS_COMPLETED = 'FETCH_ITEMS_COMPLETED'
export const GET_ITEMS = 'GET_ITEMS'
export const ADD_ITEMS = 'ADD_ITEMS'



// WEBPACK FOOTER //
// ./src/redux/types/itemsTypes.js